export enum InputType {
    TEXT_SINGLE_LINE,
    CHECKBOX,
    NUMBER,
    EMAIL,
    PASSWORD,
    DATE,
    DATE_TIME,
    DATE_TIME_LOCAL,

    TEXT_MULTI_LINE,
    WYSIWYG,

    SELECT
}

export const fieldNamePattern = /^(\w+)\[(\d+)\]$/
export const fieldDefinitions = (fieldName: string) => {
    const definitions: {
        name: string
        index?: number
    }[] = []

    fieldName.split(".").forEach((f: string) => {
        if (!fieldNamePattern.test(f)) {
            definitions.push({
                name: f
            })
        } else {
            const matches = fieldNamePattern.exec(f)
            const name = matches?.at(1)
            const index = matches?.at(2)
            if (!name || !index)
                return

            definitions.push({
                name: name,
                index: parseInt(index)
            })
        }
    })

    return definitions
}
